



















































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Ref, Watch} from 'vue-property-decorator'
import User from '@/modules/user/model/User'
import {Action, State, Mutation, Getter} from 'vuex-class'
import PostalCodeSearch from '@/modules/geo/components/PostalCodeSearch.vue';
import {Colors, notify} from '@/modules/core/notification'
import UserAttributes from '@/modules/user/components/UserAttributes.vue';
import {Route} from 'vue-router';
import ConfirmDeleteUser from '@/modules/user/components/ConfirmDeleteUser.vue';
import SessionList from '@/modules/user/components/SessionList.vue';
import Loader from '@/components/Loader.vue';
import UserGroupList from '@/modules/user/components/UserGroup/UserGroupList.vue';
import RegisterPlatformUser from '@/modules/app-router/components/Unigest/RegisterPlatformUser.vue';
import UserInfo from "@/modules/user/components/UserInfo.vue";
import PasswordChange from "@/modules/user/components/PasswordChange.vue";
import UserPlatformWidget from '@/modules/app-router/components/Unigest/UserPlatformWidget.vue';
/**
 * Pantalla para la visualización y edición de un usuario
 *
 * Desde esta pantalla un administrador o usuario con permisos puede modificar datos de
 * otro usuario o de si mismo.
 *
 * Permite:
 *  - Editar correo, nombre, nick, código postal y estado de verificación
 *  - Modificar la contraseña de un usuario existente o definirla para un usuario nuevo
 *  - Modificar los atributos del usuario
 *  - Ver y eliminar sesiones de usuario (componente SessionList)
 *  - Eliminar el usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        PasswordChange,
        UserInfo,
        UserGroupList,
        Loader,
        SessionList,
        ConfirmDeleteUser,
        UserAttributes,
        PostalCodeSearch,
        RegisterPlatformUser,
        UserPlatformWidget,
    },
})
export default class UserDetail extends Vue {
    /**
     * Referencia al componente que contiene los campos del usuario
     */
    @Ref('info')
    info: UserInfo

    public loading = true

    /**
     * Indica si el formulario con los datos del usuario es válido.
     * El formulario se encuentra en el componente UserInfo
     */
    public formIsValid = false

    /**
     * Usuario en edición cargado desde el estado de la aplicación
     */
    @State(state => state.user.currentUser)
    public user: User

    /**
     * Indica si la aplicación esta comprobado la disponibilidad del correo electrónico introducido en
     * la ficha del usuario
     */
    @State(state => state.user.checkingEmailAvailability)
    public checkingEmailAvailability: boolean

    @Action('user/loadUser')
    public loadUser: (id: number | 'nuevo') => void

    @Mutation('user/REMOVE_GROUP_FROM_CURRENT_USER')
    public removeGroup: (group: number) => void

   /**
    * Comprueba si el módulo argumentado se encuentra activo en la aplicación
    */
    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean

    public userSaveConfirm = false
    public saving = false
    public passwordChange = false
    public confirmDeleteUser = false
    public addGroupDialog = false
    public unigestDialog = false
    public window = 0
    public mobileActions = false


    /**
     * Observa la ruta actual, cuando cambia carga el usuario asociado al ID
     * definido en la ruta
     */
    @Watch('$route', {immediate: true})
    public async onRoute (route: Route) {
        const id = this.$route.params.id as any
        this.window = 0

        if (id === this.user.id.toString()) {
            return
        }

        this.loading = true
        await this.loadUser(id)

        if (this.info) {
            this.info.resetValidation()
        }

        this.loading = false
    }

    /**
     * Crea un array de pares clave/valor en base al diccionario de atributos del
     * usuario
     */
    public get attributes (): Array<{key: string, value: any}> {
       const attrs = this.user.attributes
       return Object.keys(attrs).map(k => ({key: k, value: attrs[k]}))
    }

    /**
     * Guardar cambios del usuario
     */
    public async save () {
        this.saving = true
        const isNew = this.user.isNew
        // Solicita a la aplicación que actualiza en el servidor los cambios realizados sobre el usuario
        // actual
        await this.$store.dispatch('user/saveUser')

        notify(`El usuario ${this.user.id} se ha guardado correctamente`, Colors.Success, {
            goToAction: {
                buttonName: 'Ver usuario',
                route: {
                    name: 'user-detail',
                    params: { id: this.user.id.toString() },
                },
            },
        })
        this.saving = false
        this.userSaveConfirm = false
        if (isNew) {
            await this.$router.replace({name: 'user-detail', params: {id: this.user.id.toString()}})
        }
    }

    /**
     * Cuando el componente es destruido modifica el estado de la aplicación para
     * eliminar el usuario del store.
     */
    public destroyed () {
        this.$store.commit('user/RESET_CURRENT_USER')
    }

    /**
     * Captura cualquier error producido dentro del componente, restablece la pantalla a un
     * estado válido y notifica al usuario.
     *
     * @param error
     */
    public errorCaptured (error: Error) {
        this.saving = false
        this.userSaveConfirm = false

        notify(error.message, Colors.Error)
    }
    
    onRegisterPlatformUserClosed (tipo: number) {
        if(tipo === 1 || tipo === 2 || tipo === 3 ){
            this.save()
            if( this.$refs && this.$refs.userPlatformWidget){
                (this.$refs.userPlatformWidget as Vue & { refresh: () => void }).refresh() //this.$refs.userPlatformWidget.refresh() 
            }
        }
    }

    /*public get isShowSwitchRegistrar() {
        return this.moduleIsEnabled('app-router') && this.user.isNew
    }

    onShowDialogoRegisterPlatformUser(){

        if(this.user.isNew){
            throw new Error('Debe de guardar los cambios antes de registrar usuario en la plataforma Unigest.net')
            return;
        }

        let serial = ''
        if(this.user && this.user.groups && this.user.groups.length > 0){
            serial = this.user.groups[0].attributes.SERIAL_NUMBER
        }
        if(serial === undefined || serial.length <= 4){
            throw new Error('Debe de asingar un numero serie al usuario.')
            return;
        }
        this.unigestDialog = true
    }

    

    public get isCanRegisterPlatformUser() {
         return (!this.user.isNew && this.moduleIsEnabled('app-router'))
    }
    */
}
